<script lang="ts" setup>
import { MediaImageFragment, ParagraphTestimonial } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphTestimonial
}>()

const image = computed(() => props.entity.fieldImage?.entity as MediaImageFragment)
const text = computed(() => props.entity.fieldQuote?.processed || '')
const author = computed(() => props.entity.fieldDescription?.processed || '')
const byline = computed(() => props.entity.fieldByline || '')
</script>

<template>
  <Section>
    <blockquote v-animate="{ cluster: true }" class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <div v-animate="{ animation: 'vertical-reveal' }" class="quote text-xlarge" v-html="text" />
      <cite v-animate="{ animation: 'vertical-reveal' }" :class="{ 'has-image': !!image }">
        <Image v-if="image" :entity="image" type="author-thumbnail" />
        <div>
          <div class="author text-small" v-html="author" />
          <p class="byline text-xsmall">{{ byline }}</p>
        </div>
      </cite>
    </blockquote>
  </Section>
</template>
<style scoped lang="scss">
blockquote {
  border-left: 1px solid var(--c-blue-70);
  padding-left: 24px;
  .quote {
    color: var(--c-primary);
    margin-bottom: 40px;
    :deep(p) {
      &:before {
        content: '«';
      }

      &:after {
        content: '»';
      }
    }
  }
  cite {
    display: grid;
    grid-template-columns: 100%;

    &.has-image {
      grid-template-columns: 60px 1fr;
      gap: 16px;
      align-items: center;
    }

    img {
      border-radius: 50%;
      aspect-ratio: 1;
    }

    .author {
      font-weight: bold;
      color: var(--c-primary);

      :deep(p) {
        font-style: normal;
        margin-bottom: 0;
      }
    }
    p {
      margin-bottom: 0;
      font-style: normal;
      color: var(--c-text-medium);
    }
  }
}
</style>
